import { render } from "./ChatModerationSheet.vue?vue&type=template&id=4afda714&scoped=true"
import script from "./ChatModerationSheet.vue?vue&type=script&lang=js"
export * from "./ChatModerationSheet.vue?vue&type=script&lang=js"

import "./ChatModerationSheet.vue?vue&type=style&index=0&id=4afda714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afda714"]])

export default __exports__